/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MeResponseDto } from '../../models/me-response-dto';

export interface AuthControllerGetMe$Params {
}

export function authControllerGetMe(http: HttpClient, rootUrl: string, params?: AuthControllerGetMe$Params, context?: HttpContext): Observable<StrictHttpResponse<MeResponseDto>> {
  const rb = new RequestBuilder(rootUrl, authControllerGetMe.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MeResponseDto>;
    })
  );
}

authControllerGetMe.PATH = '/auth/me';
